module.exports = __webpack_public_path__ + "img/logo.9d6a7594.png";